import { Segment } from '@dna/analytics'

if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super()

        if (!this.hasAttribute('available')) return

        this.errorHtml =
          this.querySelector('template').content.firstElementChild.cloneNode(
            true,
          )
        this.onClickRefreshList = this.onClickRefreshList.bind(this)
        this.fetchAvailability(this.dataset.variantId)
      }

      connectedCallback() {
        this.$pickupAvailabilityParent = this.closest('.pickup-availability')
        this.addEventListener('click', this.handleClick)
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick)

        if (this.$pickupAvailabilityDrawers?.length) {
          for (const $drawer of this.$pickupAvailabilityDrawers) {
            $drawer.removeEventListener('click', this.handleClick)
          }
        }
      }

      fetchAvailability(variantId) {
        this.dataset.variantId = variantId
        let rootUrl = this.dataset.rootUrl
        if (!rootUrl.endsWith('/')) {
          rootUrl = `${rootUrl}/`
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section')
            this.renderPreview(sectionInnerHTML)
            if (text.includes('is-available')) {
              this.$pickupAvailabilityParent?.classList.add('is-available')
            } else {
              this.$pickupAvailabilityParent?.classList.remove('is-available')
            }
          })
          .catch((e) => {
            const button = this.querySelector('button')
            if (button)
              button.removeEventListener('click', this.onClickRefreshList)
            this.renderError()
          })
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId)
      }

      handleClick = (evt) => {
        const $button =
          evt.target.closest('.js-check-other-stores') ||
          evt.target.closest('.js-check-store') ||
          evt.target.closest('.js-product-docked-cta') ||
          evt.target
            .closest('.js-product-form')
            ?.querySelector('.js-product-cta-retail-exclusive')

        if ($button) {
          // @segment
          Segment.protect(() => {
            const eventName = $button.dataset.showSingle
              ? Segment.CONSTANTS.EVENTS.STORE_AVAILABILITY_STORE_CLICKED
              : $button.classList.contains('js-check-other-stores')
                ? Segment.CONSTANTS.EVENTS.STORE_AVAILABILITY_CHECK_ADDITIONAL
                : ''

            if (eventName?.length) {
              Segment.track(eventName, {
                store_availability_store_name: this.closestLocation,
              })
            }
          })

          if (this.$pickupAvailabilityDrawers?.length) {
            for (const $drawer of this.$pickupAvailabilityDrawers) {
              const drawerId = $drawer.getAttribute('data-id')
              const targetId = $button.dataset.id || this.dataset.variantId
              if (targetId && drawerId) {
                if (targetId === drawerId) {
                  const $viewAllStoresButton = $drawer.querySelector(
                    '.js-pickup-availability-view-all',
                  )
                  const $pickupAvailabilityList = $drawer.querySelector(
                    '.pickup-availability-list',
                  )
                  if ($button.dataset.showSingle) {
                    $pickupAvailabilityList.classList.add(
                      'pickup-availability-list--single',
                    )
                    $viewAllStoresButton.classList.remove('hidden')
                  } else {
                    $pickupAvailabilityList.classList.remove(
                      'pickup-availability-list--single',
                    )
                    $viewAllStoresButton.classList.add('hidden')
                  }
                  $drawer.querySelector('sl-drawer').show()
                  return
                }
              }
            }
          }
        }

        const $viewAllStores = evt.target.closest(
          '.js-pickup-availability-view-all',
        )
        if ($viewAllStores) {
          const $pickupAvailabilityDrawer = $viewAllStores.closest(
            '.js-pickup-availability-drawer',
          )
          const $pickupAvailabilityList =
            $pickupAvailabilityDrawer?.querySelector(
              '.pickup-availability-list',
            )
          $pickupAvailabilityList?.classList.remove(
            'pickup-availability-list--single',
          )
          $viewAllStores.classList.add('hidden')

          // @segment
          Segment.protect(() => {
            Segment.track(
              Segment.CONSTANTS.EVENTS.STORE_AVAILABILITY_VIEW_ALL,
              {
                store_availability_store_name: this.closestLocation,
              },
            )
          })
        }
      }

      renderError() {
        this.innerHTML = ''
        this.appendChild(this.errorHtml)

        this.querySelector('button').addEventListener(
          'click',
          this.onClickRefreshList,
        )
      }

      renderPreview(sectionInnerHTML) {
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = ''
          this.removeAttribute('available')
          return
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          'pickup-availability-preview',
        ).outerHTML
        this.setAttribute('available', '')

        const $oldDrawers = document.querySelectorAll(
          '.pickup-availability-drawer',
        )
        if ($oldDrawers.length) {
          for (const $drawer of $oldDrawers) {
            $drawer.remove()
          }
        }
        document.body.appendChild(
          sectionInnerHTML.querySelector('.pickup-availability-drawer'),
        )

        this.$checkStore = this.querySelector('.js-check-store')
        this.closestLocation = this.$checkStore?.textContent
          .replace(',', '')
          .trim()
        this.$pickupAvailabilityDrawers = document.querySelectorAll(
          '.pickup-availability-drawer',
        )
        if (this.$pickupAvailabilityDrawers?.length) {
          for (const $drawer of this.$pickupAvailabilityDrawers) {
            $drawer.addEventListener('click', this.handleClick)
          }
        }
      }
    },
  )
}
